// The MCP Server page's AI tools and words: live's (`colortv-web/src/pages/mcp-server/
// constants.ts`), ours where our sign-in differs (spec platform/mcp-server, decision 12): a tool
// signs in with an access token of this team, never a URL of its own. Claude.ai and ChatGPT can
// send no token, so their cards are Coming soon until OAuth signs them in.
import claudeActive from "./assets/claude-active.svg";
import claude from "./assets/claude.svg";
import openAiActiveDark from "./assets/openai-active-dark.svg";
import openAiActive from "./assets/openai-active.svg";
import openAi from "./assets/openai.svg";

export type ClientId = "claude-code" | "claude-ai" | "chatgpt" | "codex";

export interface Client {
  id: ClientId;
  label: string;
  where: "Terminal" | "Web";
  icon: string;
  activeIcon: string;
  /** The active icon on a dark scheme, where live has one. */
  activeIconDark?: string;
  /** Signs in by OAuth, which is not built: its card is Coming soon. */
  soon: boolean;
}

export const CLIENTS: readonly Client[] = [
  {
    id: "claude-code",
    label: "Claude Code",
    where: "Terminal",
    icon: claude,
    activeIcon: claudeActive,
    soon: false,
  },
  { id: "claude-ai", label: "Claude.ai", where: "Web", icon: claude, activeIcon: claudeActive, soon: true },
  {
    id: "chatgpt",
    label: "ChatGPT",
    where: "Web",
    icon: openAi,
    activeIcon: openAiActive,
    activeIconDark: openAiActiveDark,
    soon: true,
  },
  {
    id: "codex",
    label: "Codex",
    where: "Terminal",
    icon: openAi,
    activeIcon: openAiActive,
    activeIconDark: openAiActiveDark,
    soon: false,
  },
];

/** What a command shows until a token is made. */
export const TOKEN_PLACEHOLDER = "<your token>";
/** The variable Codex reads the token from, so the token stays out of its config file. */
export const TOKEN_VARIABLE = "CREATED_AI_TOKEN";
/** A token for an AI tool lasts the longest a token may (identity's 1 to 90 days). */
export const TOKEN_DAYS = 90;

export const SUCCESS_NOTE = "Signed in as you, in this team: the token is the only login step";

export const STEPS = {
  makeToken: (label: string) =>
    `Make an access token for ${label}. It shows once, here; Settings, Access tokens, revokes it.`,
  claudeCode: {
    runInTerminal: "Run this in your terminal:",
    confirmConnected: "Run /mcp to confirm created-ai is connected.",
  },
  codex: {
    addServer: "Add the server to ~/.codex/config.toml:",
    setToken: `Set ${TOKEN_VARIABLE} to the token where Codex runs:`,
    restart: "Restart Codex — the created-ai tools load automatically.",
  },
} as const;

export const claudeCodeCommand = (url: string, token: string) =>
  `claude mcp add --transport http created-ai ${url} --header "Authorization: Bearer ${token}"`;

export const codexConfig = (url: string) =>
  `[mcp_servers.created-ai]\nurl = "${url}"\nbearer_token_env_var = "${TOKEN_VARIABLE}"`;

export const codexToken = (token: string) => `export ${TOKEN_VARIABLE}=${token}`;

// Live's suggestions, word for word.
export const PROMPTS = [
  "What products do we have? Pick one and pitch a campaign",
  "Describe what you’d like to design today",
  "Start from an ad idea — brainstorm 5 directions",
  "Generate 3 product shots, look at them, keep the best",
] as const;
